// @flow

import { combineReducers } from 'redux'
import app, { AppState } from './app'
import column, { ColumnState } from './column'
import {
  ConditionState,
  StatusConditionState,
  default as condition,
  default as statusCondition,
} from './condition'
import contactPersons, { ContactPersonsState } from './contactPerson'
import contactPersonsFilterList, {
  ContactPersonsFilterListState,
} from './contactPersonsFilterList'
import error, { ErrorState } from './error'
import permission, { PermissionState } from './permission'
import result, { ResultState } from './result'
import statusPanel, { StatusPanelState } from './statusPanel'
import statuses, { StatusesState } from './statuses'
import sourcingAnnotationsCandidates, {
  SourcingAnnotationsCandidatesState,
} from './sourcingAnnotationCandidates'

export type State = {
  app: AppState
  condition: ConditionState
  statusCondition: StatusConditionState
  result: ResultState
  column: ColumnState
  permission: PermissionState
  error: ErrorState
  statuses: StatusesState
  contactPersons: ContactPersonsState
  contactPersonsFilterList: ContactPersonsFilterListState
  statusPanel: StatusPanelState
  sourcingAnnotationsCandidates: SourcingAnnotationsCandidatesState
}

const rootReducer = combineReducers({
  app,
  condition,
  statusCondition,
  result,
  column,
  permission,
  error,
  statuses,
  contactPersons,
  contactPersonsFilterList,
  statusPanel,
  sourcingAnnotationsCandidates,
})

export default rootReducer
